export default "__VITE_ASSET__OsLiwBfO__"